import {configureStore} from '@reduxjs/toolkit';
import userReducer from '../model/user';
import appReducer from '../model/app';

export const store = configureStore({
    reducer: {
        user: userReducer,
        app : appReducer
    },
});